module.exports = __webpack_public_path__ + "img/A8.55f06b66.png";